import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  MenuItem,
  Grid,
  Snackbar,
  Alert,
} from "@mui/material";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const userTypes = [
  "super_admin",
  "admin",
  "manager",
  "developer",
  "marketer",
  "staff",
];

const titles = ["Mr", "Mrs", "Dr", "Prof"];

const RiteUserForm = ({ title, onSubmit, defaultValues = {} }) => {
  const [form, setForm] = useState({
    title: defaultValues.title || "",
    first_name: defaultValues.first_name || "",
    last_name: defaultValues.last_name || "",
    email: defaultValues.email || "",
    phone: defaultValues.phone || "",
    user_type: defaultValues.user_type || "",
    company_email: defaultValues.company_email || "",
    position: defaultValues.position || "",
  });

  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false });

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "phone") {
      value = value.replace(/\D/g, "").slice(0, 10);
    }

    setForm({ ...form, [name]: value });
  };

  const validate = () => {
    let err = {};

    if (!form.first_name) err.first_name = "Required";
    if (!form.last_name) err.last_name = "Required";

    if (!form.email || !emailRegex.test(form.email))
      err.email = "Invalid email";

    if (!form.user_type) err.user_type = "Required";

    setErrors(err);

    return Object.keys(err).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    onSubmit(form, setSnackbar);
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Grid container spacing={2} maxWidth={700}>
        <Grid item xs={12} md={4}>
          <TextField
            select
            label="Title"
            name="title"
            fullWidth
            value={form.title}
            onChange={handleChange}
          >
            {titles.map((t) => (
              <MenuItem key={t} value={t}>
                {t}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="First Name"
            name="first_name"
            fullWidth
            required
            value={form.first_name}
            onChange={handleChange}
            error={!!errors.first_name}
            helperText={errors.first_name}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="Last Name"
            name="last_name"
            fullWidth
            required
            value={form.last_name}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Email"
            name="email"
            fullWidth
            required
            value={form.email}
            onChange={handleChange}
            error={!!errors.email}
            helperText={errors.email}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Phone"
            name="phone"
            fullWidth
            value={form.phone}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            select
            label="User Type"
            name="user_type"
            fullWidth
            required
            value={form.user_type}
            onChange={handleChange}
            error={!!errors.user_type}
            helperText={errors.user_type}
          >
            {userTypes.map((u) => (
              <MenuItem key={u} value={u}>
                {u}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Company Email"
            name="company_email"
            fullWidth
            value={form.company_email}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Position"
            name="position"
            fullWidth
            value={form.position}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <Button variant="contained" type="submit">
            Save User
          </Button>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default RiteUserForm;
